<div class="u-flex">
  <form-control
    [control]="group.controls[passwordConfig.prop]"
    [group]="group"
    data-test-id="passwordFormControl"
    [config]="passwordConfig"
  >
  </form-control>

  <form-control
    [control]="group.controls[confirmPasswordConfig.prop]"
    [config]="confirmPasswordConfig"
    data-test-id="confirmPasswordFormControl"
    [group]="group"
  >
  </form-control>
</div>
